/**
 * @module Components.CheckoutLegalLinks
 *
 */
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

// Legal links shown below the Stripe checkout on every plan purchase/trial page
// (CN-2557). URLs are the canonical coachnow.com pages; EU rights is an anchor
// within the Terms of Service.
const TERMS_OF_SERVICE_URL = "https://coachnow.com/terms-of-service";
const PRIVACY_POLICY_URL = "https://coachnow.com/privacy-policy";
const EU_RIGHTS_URL = "https://coachnow.com/terms-of-service#EU-rights";

// Skeleton: markup + i18n are final, spacing/typography are placeholders pending
// design (CN-2557). Drop below <BillingInformation> in the left column of each
// checkout page (ProCheckout, AcademyCheckout, AnalyzeCheckout,
// StartYourFreeTrial) and below the Upgrade payment form.
const CheckoutLegalLinks = () => {
  const { t } = useTranslation();

  const links = [
    { href: TERMS_OF_SERVICE_URL, label: t("Terms of Service"), testId: "legal-link-terms" },
    { href: PRIVACY_POLICY_URL, label: t("Privacy Policy"), testId: "legal-link-privacy" },
    { href: EU_RIGHTS_URL, label: t("EU Purchaser Rights"), testId: "legal-link-eu-rights" },
  ];

  return (
    <div className={styles.container} data-testid="checkout-legal-links">
      {links.map((link, index) => (
        <React.Fragment key={link.href}>
          {index > 0 && <span className={styles.separator}>•</span>}
          <a
            className={styles.link}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={link.testId}
          >
            {link.label}
          </a>
        </React.Fragment>
      ))}
    </div>
  );
};

export default CheckoutLegalLinks;
